<template>
  <Layout>
    <div class="shopping-cart">
      <h1 class="main-title">購物車</h1>
      <h2 class="sub-title">SHOPPING CART</h2>
      
      <!-- 進度條 -->
      <div class="progress-bar">
        <div class="progress-step">
          <div class="step-number">1</div>
          <div class="step-label">購物車</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step active">
          <div class="step-number">2</div>
          <div class="step-label">結帳</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step">
          <div class="step-number">3</div>
          <div class="step-label">完成</div>
        </div>
      </div>

      <div class="cart-content">
        <!-- 左側：表單區塊 -->
        <div class="checkout-form">
          <!-- 運送方式卡片 -->
          <div class="form-card shipping-method-card">
            <h3>運送方式</h3>
            <div class="shipping-method-options">
              <div class="shipping-method-option">
                <input type="radio" id="family-mart" name="shipping-method" value="family-mart" v-model="shippingMethod">
                <label for="family-mart">
                  <div class="method-header">
                    <img :src="require('@/assets/img/family-mart.svg')" alt="全家便利商店" class="method-icon">
                    <span class="method-name">全家便利商店</span>
                  </div>
                  <span class="method-desc">預計 2-3 個工作天送達</span>
                </label>
              </div>
              <div class="shipping-method-option">
                <input type="radio" id="seven-eleven" name="shipping-method" value="seven-eleven" v-model="shippingMethod">
                <label for="seven-eleven">
                  <div class="method-header">
                    <img :src="require('@/assets/img/seven-eleven.svg')" alt="7-ELEVEN" class="method-icon">
                    <span class="method-name">7-ELEVEN</span>
                  </div>
                  <span class="method-desc">預計 2-3 個工作天送達</span>
                </label>
              </div>
              <div class="shipping-method-option">
                <input type="radio" id="home-delivery" name="shipping-method" value="home-delivery" v-model="shippingMethod">
                <label for="home-delivery">
                  <div class="method-header">
                    <img :src="require('@/assets/img/home-delivery.svg')" alt="宅配到府" class="method-icon">
                    <span class="method-name">宅配到府</span>
                  </div>
                  <span class="method-desc">預計 1-2 個工作天送達</span>
                </label>
              </div>
            </div>
          </div>

          <!-- 訂購人資訊卡片 -->
          <div class="form-card order-info-card">
            <h3>訂購人資訊</h3>
            <div class="order-info-fields">
              <div class="form-row">
                <div class="form-group">
                  <label for="lastName">姓</label>
                  <input type="text" id="lastName" v-model="orderInfo.lastName" placeholder="請輸入姓">
                </div>
                <div class="form-group">
                  <label for="firstName">名</label>
                  <input type="text" id="firstName" v-model="orderInfo.firstName" placeholder="請輸入名">
                </div>
              </div>
              <div class="form-group">
                <label for="phone">手機號碼</label>
                <input type="tel" id="phone" v-model="orderInfo.phone" placeholder="請輸入手機號碼">
              </div>
              <div class="form-group">
                <label for="email">電子郵件</label>
                <input type="email" id="email" v-model="orderInfo.email" placeholder="請輸入電子郵件">
              </div>
            </div>
          </div>

          <!-- 收件地址卡片 -->
          <div class="form-card shipping-address-card">
            <h3>收件地址</h3>
            <div class="shipping-address-fields">
              <div class="form-group">
                <label for="address">地址</label>
                <input type="text" id="address" v-model="orderInfo.address" placeholder="請輸入地址">
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="city">城市</label>
                  <input type="text" id="city" v-model="orderInfo.city" placeholder="請輸入城市">
                </div>
                <div class="form-group">
                  <label for="postalCode">郵遞區號</label>
                  <input type="text" id="postalCode" v-model="orderInfo.postalCode" placeholder="請輸入郵遞區號">
                </div>
              </div>
            </div>
          </div>

          <!-- 付款方式卡片 -->
          <div class="form-card payment-method-card">
            <h3>付款方式</h3>
            <div class="payment-method-options">
              <div class="payment-method-option">
                <input type="radio" id="credit-card" name="payment-method" value="credit-card" v-model="paymentMethod">
                <label for="credit-card">
                  <div class="method-header">
                    <div class="payment-icons">
                      <img :src="require('@/assets/img/visa.svg')" alt="Visa" class="method-icon">
                      <img :src="require('@/assets/img/master-card.svg')" alt="MasterCard" class="method-icon">
                      <img :src="require('@/assets/img/jcb.svg')" alt="JCB" class="method-icon">
                      <img :src="require('@/assets/img/unionpay.svg')" alt="UnionPay" class="method-icon">
                    </div>
                    <span class="method-name">信用卡</span>
                  </div>
                  <span class="method-desc">支援 Visa、MasterCard、JCB、銀聯</span>
                </label>
              </div>
              <div class="payment-method-option">
                <input type="radio" id="apple-pay" name="payment-method" value="apple-pay" v-model="paymentMethod">
                <label for="apple-pay">
                  <div class="method-header">
                    <img :src="require('@/assets/img/apple-pay.svg')" alt="Apple Pay" class="method-icon">
                    <span class="method-name">Apple Pay</span>
                  </div>
                  <span class="method-desc">使用 Apple Pay 快速付款</span>
                </label>
              </div>
              <div class="payment-method-option">
                <input type="radio" id="jkopay" name="payment-method" value="jkopay" v-model="paymentMethod">
                <label for="jkopay">
                  <div class="method-header">
                    <img :src="require('@/assets/img/jkopay.svg')" alt="街口支付" class="method-icon">
                    <span class="method-name">街口支付</span>
                  </div>
                  <span class="method-desc">使用街口支付快速付款</span>
                </label>
              </div>
              <div class="payment-method-option">
                <input type="radio" id="line-pay" name="payment-method" value="line-pay" v-model="paymentMethod">
                <label for="line-pay">
                  <div class="method-header">
                    <img :src="require('@/assets/img/line-pay.svg')" alt="LINE Pay" class="method-icon">
                    <span class="method-name">LINE Pay</span>
                  </div>
                  <span class="method-desc">使用 LINE Pay 快速付款</span>
                </label>
              </div>
            </div>
          </div>

          <!-- 發票資訊卡片 -->
          <div class="form-card invoice-info-card">
            <h3>發票資訊</h3>
            <div class="invoice-info-fields">
              <div class="form-group">
                <label for="invoice-type">發票類型</label>
                <select id="invoice-type" v-model="invoiceInfo.type">
                  <option value="personal">個人</option>
                  <option value="company">公司</option>
                </select>
              </div>
              <div v-if="invoiceInfo.type === 'company'" class="form-group">
                <label for="company-name">公司名稱</label>
                <input type="text" id="company-name" v-model="invoiceInfo.companyName" placeholder="請輸入公司名稱">
              </div>
              <div v-if="invoiceInfo.type === 'company'" class="form-group">
                <label for="tax-id">統一編號</label>
                <input type="text" id="tax-id" v-model="invoiceInfo.taxId" placeholder="請輸入統一編號">
              </div>
            </div>
          </div>

          <!-- 購物須知卡片 -->
          <div class="form-card shopping-notice-card">
            <h3>購物須知</h3>
            <div class="shopping-notice-content">
              <p>1. 商品將於付款完成後 1-2 個工作天內出貨</p>
              <p>2. 運送範圍僅限台灣本島地區</p>
              <p>3. 如需退換貨，請於收到商品後 7 天內提出申請</p>
              <p>4. 如有任何問題，歡迎聯繫客服中心</p>
            </div>
          </div>
        </div>
        <!-- 右側：優惠券和結帳明細 -->
        <div class="checkout-summary">
          <!-- 優惠券 -->
          <div class="coupon-section">
            <h3>優惠券</h3>
            <div class="coupon-input">
              <input 
                type="text" 
                v-model="discountCode" 
                placeholder="請輸入優惠碼"
                @keyup.enter="applyDiscount"
              >
              <button @click="applyDiscount" class="apply-btn">套用</button>
            </div>
          </div>

          <!-- 結帳明細 -->
          <div class="order-summary">
            <h3>結帳明細</h3>
            <div class="summary-details">
              <div class="summary-row">
                <span>小計</span>
                <span>$NTD {{ subtotal }}</span>
              </div>
              <div v-if="discount" class="summary-row discount">
                <span>折扣</span>
                <span>-$NTD {{ discount }}</span>
              </div>
              <div class="summary-row">
                <span>運費</span>
                <span>$NTD {{ shipping }}</span>
              </div>
              <div class="summary-row">
                <span>稅金</span>
                <span>$NTD {{ tax }}</span>
              </div>
              <div class="summary-row total">
                <span>總計</span>
                <span>$NTD {{ total }}</span>
              </div>
            </div>
          </div>

          <!-- 前往結帳按鈕 -->
          <button @click="proceedToCheckout" class="checkout-btn">
            確認結帳
          </button>

          <!-- 支援付款方式 -->
          <div class="payment-methods">
            <h3>支援付款方式</h3>
            <div class="payment-icons">
              <img v-for="(icon, index) in paymentIcons" 
                    :key="index" 
                    :src="icon" 
                    :alt="'payment-' + index">
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Layout from '@/layouts/Layout.vue'

export default {
  name: 'Cart',
  components: {
    Layout
  },
  data() {
    return {
      discountCode: '',
      discount: 0,
      shippingMethod: 'family-mart',
      paymentMethod: 'unionpay',
      orderInfo: {
        lastName: '陳',
        firstName: '小明',
        phone: '0912345678',
        email: 'test@test.com',
        address: '台北市中山區中山路一段1號',
        city: '台北市',
        postalCode: '100'
      },
      invoiceInfo: {
        type: 'personal',
        companyName: '',
        taxId: ''
      },
      paymentIcons: [
        require('@/assets/img/visa.svg'),
        require('@/assets/img/master-card.svg'),
        require('@/assets/img/apple-pay.svg'),
        require('@/assets/img/jkopay.svg'),
        require('@/assets/img/line-pay.svg'),
        require('@/assets/img/unionpay.svg')
      ],
    }
  },
  computed: {
    ...mapState(['cartItems']),
    subtotal() {
      return this.cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    },
    shipping() {
      return 10
    },
    tax() {
      return (this.subtotal - this.discount) * 0.1
    },
    total() {
      return this.subtotal - this.discount + this.shipping + this.tax
    }
  },
  methods: {
    ...mapMutations(['updateCartItemQuantity', 'removeFromCart']),
    getImageUrl(image) {
      return `/img/${image}`
    },
    updateQuantity(item, change) {
      const newQuantity = item.quantity + change
      if (newQuantity > 0) {
        this.updateCartItemQuantity({ item, quantity: newQuantity })
      }
    },
    proceedToCheckout() {
      // check if the form is valid
      if (this.orderInfo.lastName === '' || this.orderInfo.firstName === '' || this.orderInfo.phone === '' || this.orderInfo.email === '' || this.orderInfo.address === '' || this.orderInfo.city === '' || this.orderInfo.postalCode === '') {
        alert('請填寫完整資訊')
        return
      }
      // check if the shipping method is selected
      if (this.shippingMethod === '') {
        alert('請選擇運送方式')
        return
      }
      // check if the payment method is selected
      if (this.paymentMethod === '') {
        alert('請選擇付款方式')
        return
      }
      // check if the invoice info is valid
      if (this.invoiceInfo.type === '') {
        alert('請選擇發票類型')
        return
      }
      // check if the invoice info is valid
      if (this.invoiceInfo.type === 'company' && (this.invoiceInfo.companyName === '' || this.invoiceInfo.taxId === '')) {
        alert('請填寫完整發票資訊')
        return
      }
      // save the order info to the store
      this.$store.commit('setOrderInfo', this.orderInfo)
      this.$store.commit('setInvoiceInfo', this.invoiceInfo)
      this.$store.commit('setShippingMethod', this.shippingMethod)
      this.$store.commit('setPaymentMethod', this.paymentMethod)
      // redirect to the done page
      this.$router.push('/checkout/done')
    },
    applyDiscount() {
      if (this.discountCode === 'SAVE20') {
        this.discount = this.subtotal * 0.2
      } else if (this.discountCode === 'SAVE10') {
        this.discount = this.subtotal * 0.1
      } else {
        this.discount = 0
        alert('無效的優惠碼')
      }
    }
  }
}
</script>

<style scoped>
.shopping-cart {
  max-width: 1200px;
  margin: 80px auto 2rem auto;
  padding: 0 2rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5rem;
}

.sub-title {
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #F99393;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.progress-step.active .step-number {
  background-color: #F99393;
  color: white;
}

.progress-line {
  position: relative;
  top: -15px;
  width: 100px;
  height: 2px;
  background-color: #F99393;
  margin: 0 1rem;
}

.cart-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cart-item {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 1rem;
  padding: 2rem;
  background-color: #FBFBFB;
  border-radius: 8px;
}

.item-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.item-name {
  font-size: 1.1rem;
  font-weight: 500;
}

.item-variants {
  display: flex;
  gap: 1rem;
}

.variant {
  color: #666;
  font-size: 0.9rem;
}

.item-price {
  font-weight: 500;
}

.item-quantity {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: none;
  cursor: pointer;
}

.quantity {
  min-width: 30px;
  text-align: center;
}

.remove-btn {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
}

.checkout-summary {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.coupon-section,
.order-summary,
.payment-methods {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
}

.coupon-input {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.coupon-input input {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.apply-btn {
  padding: 0.5rem 1rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.summary-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  color: #666;
}

.summary-row.discount {
  color: #4CAF50;
}

.summary-row.total {
  font-weight: bold;
  color: #000;
  font-size: 1.2rem;
  border-top: 1px solid #ddd;
  padding-top: 1rem;
  margin-top: 1rem;
}

.checkout-btn {
  width: 100%;
  padding: 1rem;
  background-color: #F99393;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.checkout-btn:hover {
  color: white;
}

.payment-icons {
  display: flex;
  gap: 1rem;
  font-size: 2rem;
  color: #666;
}

.checkout-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #F99393;
}

.shipping-method-options,
.payment-method-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.shipping-method-option,
.payment-method-option {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.shipping-method-option:hover,
.payment-method-option:hover {
  border-color: #F99393;
  background-color: #FFF5F5;
}

.shipping-method-option input[type="radio"],
.payment-method-option input[type="radio"] {
  margin-top: 0.4rem;
}

.shipping-method-option input[type="radio"]:checked + label,
.payment-method-option input[type="radio"]:checked + label {
  color: #F99393;
}

.shipping-method-option input[type="radio"]:checked + label .method-header,
.payment-method-option input[type="radio"]:checked + label .method-header {
  color: #F99393;
}

.method-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.payment-icons .method-icon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.method-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.method-name {
  font-weight: 600;
  color: #333;
}

.method-desc {
  font-size: 0.9rem;
  color: #666;
}

.shopping-notice-content {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
}

.shopping-notice-content p {
  margin-bottom: 0.5rem;
}
</style> 